/*
* @requires  ../util/websocket.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {

    function PdfWebsocket(param,m,callback) {
        this.host="ws://127.0.0.1:18216/pdf";
        this.context=param.context;
        this.websocket=$m.createWebSocketWrapper(param,this.host);
        this.setEventCallback(m,callback);
        this.websocket.connect(param);
    }

    PdfWebsocket.prototype.setEventCallback=function(m,callback){
        this.middlewareObj=m;
        this.websocket.setEventCallback(m,callback);
    };

    PdfWebsocket.prototype.openPdf=function(param){
        var name="openPdf";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["fileName","preRenderCount","maxCachePageCount"]);

        this.websocket.sendMessage({
            fun: 'OpenPdf',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    PdfWebsocket.prototype.closePdf=function(param){
        var name="closePdf";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["fileId"]);

        this.websocket.sendMessage({
            fun: 'ClosePdf',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    PdfWebsocket.prototype.getPdfInfo=function(param){
        var name="getPdfInfo";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["fileId"]);

        this.websocket.sendMessage({
            fun: 'GetPdfInfo',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    PdfWebsocket.prototype.getPdfPageInfo=function(param){
        var name="getPdfPageInfo";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["fileId","pageIndex"]);

        this.websocket.sendMessage({
            fun: 'GetPdfPageInfo',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    PdfWebsocket.prototype.savePdf=function(param){
        var name="savePdf";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["fileId","fileName"]);

        this.websocket.sendMessage({
            fun: 'SavePdf',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    PdfWebsocket.prototype.pdfRenderPage=function(param){
        var name="pdfRenderPage";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["fileId","pageIndex","dpi"]);

        this.websocket.sendMessage({
            fun: 'PdfRenderPage',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    PdfWebsocket.prototype.getPdfOutlines=function(param){
        var name="getPdfOutlines";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["fileId"]);

        this.websocket.sendMessage({
            fun: 'GetPdfOutlines',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };


    $m.PdfWebsocket=PdfWebsocket;

})(HebcaMiddleware);
